import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  user: JSON.parse(localStorage.getItem("user")),
  paid: JSON.parse(localStorage.getItem("paid")),
  isLoggedIn: localStorage.getItem("isLogin"),
  message: "",
  error: "",
};
//https://htacademy.in/api/v1/login
export const loginUser = createAsyncThunk("loginUser", async (data) => {
  const user = await fetch("http://localhost:8000/api/login", {
    method: "post",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await user.json();
});

export const registerUser = createAsyncThunk("registerUser", async (data) => {
  const user = await fetch("https://htacademy.in/api/v1/register", {
    method: "post",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await user.json();
});

const authSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state, action) => {
      localStorage.clear();
      state.isLoggedIn = false;
    },
  },
  extraReducers: {
    [loginUser.fulfilled]: (
      state,
      { payload: { message, user, paiduser } }
    ) => {
      if (user) {
        localStorage.setItem("isLogin", true);
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("paid", JSON.stringify(paiduser));
        state.isLoggedIn = localStorage.getItem("isLogin");
        state.user = JSON.parse(localStorage.getItem("user"));
        state.paid = JSON.parse(localStorage.getItem("paid"));
      } else {
        state.error = "Invalid Credentials";
      }
    },
    [loginUser.rejected]: (state, action) => {
      localStorage.clear();
      state.isLoggedIn = false;
    },

    [registerUser.fulfilled]: (state, { payload: { message } }) => {
      state.message = message;
    },
    [registerUser.rejected]: (state, action) => {
      localStorage.clear();
      state.isLoggedIn = false;
    },
  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
